import {useEffect} from "react"
import {useIsUnitSuperUser, useUserClaimsData} from "../services/auth"
import {configureProductionWidget, loadZendeskSnippet, ZENDESK_SCRIPT_ID} from "./zendeskWidget"

const ZENDESK_URL = "https://static.zdassets.com/ekr/snippet.js?key=159cfb9c-4952-480f-b264-68f0fa57343d"

const useZendesk = (shouldInitialize = false) => {
	const userTokenData = useUserClaimsData()
	const isSuperUser = useIsUnitSuperUser()

	useEffect(() => {
		if (!shouldInitialize) {
			return
		}

		return loadZendeskSnippet({
			id: ZENDESK_SCRIPT_ID,
			src: ZENDESK_URL,
			onReady: () => configureProductionWidget(userTokenData, isSuperUser),
		})
	}, [shouldInitialize, userTokenData, isSuperUser])
}

export default useZendesk
